import { LazyImage, Typography } from '@frontend/design_system'
import trashIcon from 'assets/icons/red600/red600_trash_16x16.webp'
import jpegIcon from 'assets/img/jpeg.webp'
import jpgIcon from 'assets/img/jpg.webp'
import pngIcon from 'assets/img/png.webp'
import pdfIcon from 'assets/img/pdf.webp'
import { DocumentItemProps } from './types'
import styles from './styles.module.scss'

const icons: Record<string, string> = {
  jpeg: jpegIcon,
  jpg: jpgIcon,
  png: pngIcon,
  pdf: pdfIcon,
}

export const DocumentItem = ({
  type,
  url,
  id,
  name,
  onDelete,
  withDownload,
}: DocumentItemProps) => {
  const downloadDocument = () => {
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', name as string)
    link.setAttribute('target', '_blank')
    document.body.appendChild(link)
    link.click()
  }

  return (
    <div
      key={id || url || name}
      className={styles.file}
      onClick={withDownload ? downloadDocument : undefined}
    >
      <div className={styles['file-content']}>
        <div className={styles['file-header-left']}>
          <LazyImage src={icons[type]} width={20} height={20} />
          <Typography
            name="Button2"
            className={styles['file-header-name']}
            title={name}
          >
            {name}
          </Typography>
        </div>
        {id && onDelete && (
          <LazyImage
            src={trashIcon}
            minWidth={16}
            height={16}
            priority
            className={styles['file-header-trash']}
            onClick={() => onDelete(id)}
          />
        )}
      </div>
    </div>
  )
}
